import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./EmailVerifyConfirm.css";

const EmailVerifyConfirm = () => {
  const navigate = useNavigate();

  const handleOkClick = () => {
    navigate('/login');
  };

  return (
    <div className="email-verify-confirm-container">
     
      <h2>Email verified successfully!</h2>
      <p>You have successfully verified your email. Please use this email when you sign in.</p>
      <button onClick={handleOkClick}>Ok</button>
    </div>
  );
};

export default EmailVerifyConfirm;
